import "./styles.scss";
import Hairstyle from "../../components/Hairstyle/Hairstyle";
import { servicesSection } from "../../texts";
import { useEffect } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { gsap } from "gsap";

const Services = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    let hasPlayed = false;

    const animation = gsap
      .timeline({
        paused: true,
      })
      .to(".servicesContainer", {
        opacity: 1,
        y: -100,
      });

    ScrollTrigger.create({
      trigger: "#services",
      start: "-10% 80%",
      end: "30% 90%",
      onEnter: () => {
        if (!hasPlayed) {
          animation.play();
          hasPlayed = true;
        }
      },
    });
  }, []);

  return (
    <section id="services">
      <div className="servicesContainer">
        <div className="subheader">{servicesSection.title1}</div>
        <div className="subheaderBigger">{servicesSection.title2}</div>
        <p className="serviceParagraph">{servicesSection.paragraph1}</p>
        <div className="hairstylesContainer">
          {servicesSection.hairstyles.map((hairstyle, index) => {
            return (
              <Hairstyle
                key={hairstyle.name}
                number={index + 1}
                name={hairstyle.name}
                description={hairstyle.description}
                price={hairstyle.price}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
